import React from 'react'

interface CarVerticalLogoProps {
    className?: string
}

export default function CarVerticalLogo({ className = '' }: CarVerticalLogoProps) {
    return (
        <svg className={className} viewBox="0 0 636 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M30.6731 26.9102C46.1815 26.9102 56.1758 34.8885 58.244 48.5323H42.7356C41.186 42.9557 37.0496 39.9519 30.6731 39.9519C21.3662 39.9519 16.1989 47.1603 16.1989 57.4549C16.1989 67.7495 21.713 74.9579 31.02 74.9579C37.7401 74.9579 41.186 71.9541 42.7388 66.3775H58.2472C56.1789 80.0181 46.1847 87.9996 30.6763 87.9996C10.4238 87.9965 0 74.6126 0 57.4517C0 40.2909 11.4579 26.9102 30.6731 26.9102Z"
                fill="#0073F0"
            />
            <path
                d="M260.609 27.9395H307.135V40.6358H276.461V50.9304H301.62V62.6001H276.461V74.2699H308.169V86.9662H260.609V27.9395Z"
                fill="#0073F0"
            />
            <path d="M374.648 27.9395H429.1V40.978H409.802V86.9662H393.946V40.978H374.648V27.9395Z" fill="#0073F0" />
            <path
                d="M491.084 26.9102C506.592 26.9102 516.587 34.8885 518.655 48.5323H503.146C501.594 42.9557 497.457 39.9519 491.084 39.9519C481.777 39.9519 476.61 47.1603 476.61 57.4549C476.61 67.7495 482.124 74.9579 491.431 74.9579C498.151 74.9579 501.597 71.9541 503.15 66.3775H518.658C516.59 80.0181 506.596 87.9996 491.087 87.9996C470.838 87.9996 460.414 74.6157 460.414 57.4549C460.414 40.2941 471.872 26.9102 491.087 26.9102"
                fill="#0073F0"
            />
            <path d="M452.017 27.959H436.051V86.9414H452.017V27.959Z" fill="#0073F0" />
            <path d="M592.305 27.8945H608.16V73.8796H635.731V86.9213H592.305V27.8945Z" fill="#0073F0" />
            <path
                d="M263.301 0L235.657 86.9163H203.075L184.289 28.0004H201.576L219.366 83.2376L246.001 0H263.301Z"
                fill="#0073F0"
            />
            <path
                d="M181.954 47.3251C181.954 35.31 173.694 27.9336 158.52 27.9336H129.574V86.9635H145.426V67.4073H146.575V67.3724H158.52L164.731 86.916H181.05L173.598 63.4213C179.087 59.8091 181.954 54.0455 181.954 47.3219M145.423 55.7344V39.9455H157.148C162.666 39.9455 165.758 42.8701 165.758 47.4993C165.758 52.4708 162.666 55.7375 157.148 55.7375H145.423V55.7344Z"
                fill="#0073F0"
            />
            <path
                d="M370.267 47.3251C370.267 35.31 362.006 27.9336 346.832 27.9336H317.887V86.9635H333.739V67.4073H334.887V67.3724H346.832L353.043 86.916H369.363L361.911 63.4213C367.4 59.8091 370.267 54.0455 370.267 47.3219M333.736 55.7344V39.9455H345.461C350.978 39.9455 354.071 42.8701 354.071 47.4993C354.071 52.4708 350.978 55.7375 345.461 55.7375H333.736V55.7344Z"
                fill="#0073F0"
            />
            <path
                d="M104.974 27.9727H78.5579L59.8008 86.9519H75.9615L79.5061 75.8588H104.01L107.573 86.9519H123.74L104.977 27.9727H104.974ZM83.2797 63.85L91.7689 37.1994L100.347 63.85H83.2797Z"
                fill="#0073F0"
            />
            <path
                d="M566.122 27.9727H539.706L520.949 86.9519H537.11L540.655 75.8588H565.158L568.722 86.9519H584.889L566.125 27.9727H566.122ZM544.428 63.85L552.917 37.1994L561.496 63.85H544.428Z"
                fill="#0073F0"
            />
            <path
                d="M263.301 0L235.657 86.9163H203.075L184.289 28.0004H201.576L219.366 83.2376L246.001 0H263.301Z"
                fill="#0073F0"
            />
        </svg>
    )
}
